import { formatToDevanagariStyle } from "@/utilities/helper"
import { useNavigate } from "react-router-dom"

type ProductGroupProps = {
  product: {
    id: number
    code: string
    description: string
    name: string
    product_max_sell_price: number
    product_min_sell_price: number
    product_max_final_price?: number
    product_min_final_price?: number
    has_discount?: boolean
    thumbnail?: string
  }
}

export default function ProductGroup({ product }: ProductGroupProps) {
  const navigate = useNavigate()

  const getProductPrice = (minPrice: number, maxPrice: number) => {
    if (minPrice !== maxPrice) {
      return `Rs. ${formatToDevanagariStyle(minPrice)} - Rs. ${formatToDevanagariStyle(maxPrice)}`
    }
    return `Rs. ${formatToDevanagariStyle(minPrice)}`
  }

  const hasDiscount = product.has_discount === true
  const originalPrice = getProductPrice(
    product.product_min_sell_price,
    product.product_max_sell_price
  )
  const finalPrice = getProductPrice(
    product.product_min_final_price ?? product.product_min_sell_price,
    product.product_max_final_price ?? product.product_max_sell_price
  )

  return (
    <div
      className="group relative cursor-pointer"
      onClick={() => navigate(`/product/${product.code}`)}
    >
      <div className="h-[230px] aspect-w-1 aspect-h-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-w-7 xl:aspect-h-8">
        <img
          src={product.thumbnail}
          alt={product.name}
          className="h-full w-full object-cover object-center group-hover:opacity-75 transition"
        />
      </div>
      <h3 className="mt-4 text-sm text-gray-700 hover:text-indigo-600">
        {product.name}
      </h3>
      <div className="mt-1 flex items-center justify-between">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          {hasDiscount && (
            <p className="text-sm text-gray-500 line-through">
              {originalPrice}
            </p>
          )}
          <p
            className={`text-lg font-medium ${hasDiscount ? "text-red-600" : "text-gray-900"}`}
          >
            {hasDiscount ? finalPrice : originalPrice}
          </p>
          {hasDiscount && (
            <span className="rounded bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700">
              Sale
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
